import React from 'react'
import { StyledCheckbox } from 'components'
import { Box } from '@material-ui/core'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import useStyles from './useStyles'

const Category = ({ depth, parentId, items, input, onChange }) => {

    const classes = useStyles()

    return (
        <Box display="flex" flexDirection={depth === 3 ? "row" : "column"} flexWrap="wrap" color="primary">
            {items
                .filter(category => category.parent_id === parentId)
                .map(category => (
                    <Box className={clsx({
                        [classes.chipLevel1]: depth === 1,
                        [classes.chipLevel2]: depth === 2,
                        [classes.chipLevel3]: depth !== 1 && depth !== 2,
                    })}
                        key={category.id}
                        display="flex"
                        flexDirection="column">
                        <StyledCheckbox
                            input={{
                                value: input.value.includes(category.uuid),
                                onChange: onChange(category.uuid),
                            }}
                            label={category.title}
                        />
                        {depth < 3 && (
                            <Category
                                depth={depth + 1}
                                parentId={category.id}
                                items={items}
                                input={input}
                                onChange={onChange}
                            />
                        )}
                    </Box>
                ))}
        </Box>
    )
}

Category.defaultProps = {
    parentId: null,
    items: [],
    input: {
        value: [],
        onChange: () => { },
    },
}

Category.propTypes = {
    depth: PropTypes.number.isRequired,
    parentId: PropTypes.number,
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        parent_id: PropTypes.number,
    })),
    input: PropTypes.shape({
        value: PropTypes.arrayOf(PropTypes.string),
        onChange: PropTypes.func,
    }),
    onChange: PropTypes.func.isRequired,
}

export default Category